import axios from "../utils/axios";

export const getBlogSection = async () => {
    const response = await axios.get("/settings/blog-page");
    return response.data;
};

export const updateBlogSection = async (data) => {
    const response = await axios.put("/settings/blog-page", data);
    return response.data;
};
